<template>
    <SkeletonLoader v-if="loading" style="width: 40px; border-radius: 0.75rem; margin: 0" />
    <span v-else class="counter-pill">
        {{ counter }}
    </span>
</template>
<script lang="ts" setup>
import SkeletonLoader from '@/Components/SkeletonLoader.vue';
import { trans } from '@/mixins/i18n';
import { computed } from 'vue';

const props = defineProps({
    loading: Boolean,
    count: Number,
});

const counter = computed(() => {
    if (props.count === undefined || props.count === null) {
        return trans('general.not_available');
    }

    return props.count;
});
</script>
